
import React from "react";
import { Download, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";

interface InstallationDocSectionProps {
  onDownload: () => void;
}

const InstallationDocSection = ({ onDownload }: InstallationDocSectionProps) => {
  return (
    <section className="bg-black/30 border border-primary/20 rounded-lg p-6">
      <h2 className="text-xl mb-4 flex items-center gap-2 text-foreground/80">
        <Settings className="h-5 w-5" />
        Instalacijska dokumentacija
      </h2>
      <p className="text-sm text-foreground/70 mb-4">
        Preuzmite detaljnu dokumentaciju za instalaciju i konfiguraciju 7GC Dashboard aplikacije
      </p>
      <Button 
        onClick={onDownload}
        className="bg-primary/20 hover:bg-primary/30 text-foreground"
      >
        <Download className="mr-2 h-4 w-4" />
        Preuzmi instalacijsku dokumentaciju
      </Button>
    </section>
  );
};

export default InstallationDocSection;
